import axios from '../axios';

export const postSong = (payload) => axios.post('/admin/upload-song', payload);

export const getSongUploadUrl = (payload) => axios.post('/admin/get-song-upload-url', payload);

export const fetchAllSongs = (payload) => axios.post('/songs', payload);

export const deleteSong = (id) => axios.delete(`/songs/${id}`);

export const updateSong = (id, payload) => axios.post(`/songs/${id}`, payload);

export const fetchSongById = (id) => axios.get(`/songs/song-info/${id}`);

export const getSongImageUploadUrl = (id, payload) => axios.post(`/songs/${id}/get-image-upload-url`, payload);

export const uploadAvatar = (id, payload) => axios.post(`/songs/${id}/upload-image`, payload);

export const fetchSongLicence = (payload) => axios.post(`/media/documents`, payload);

